import React from 'react'
import { FaCheckCircle } from "react-icons/fa";
import { RiAiGenerate } from "react-icons/ri";
import Button from '../ui/Button';
import PdfTextExtractor from './PDFtextExtractor';
import { MAX_TITLE_LENGTH } from '../../data/constant';

// Main component for PPT input interface
function PPTInputUI({
  pptName,
  setPptName,
  textView,
  handleTextButtonClick, 
  handleUploadButtonClick,
  pdfText,
  setPdfText,
  setTextView,
  templates,
  selectedTemplate,
  handleSelectTemplate,
  isLoading,
  handleGenerateSlides,
}) {
  return (
    <div>
      <div className="flex flex-col border h-full p-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-black">
            Generate Presentation With AI
          </h1>
          <Button 
            disabled={isLoading || (!pdfText?.trim()) || (!pptName?.trim())}
            onClick={() => {
              handleGenerateSlides();
              console.info('Generating slides');
            }}
          >
            <RiAiGenerate className="text-xl" />
            {isLoading ? "Generating..." : " Generate Slides"}
          </Button>
        </div>

        {/* Title input */}
        <div className="my-4">
          <label className="text-xl font-semibold text-gray-700 mb-1 block">
            Presentation Title <span className="text-red-500">*</span>
          </label>
          <input
            placeholder="Presentation text"
            value={pptName}
            placeholder="Enter Title"
            maxLength={MAX_TITLE_LENGTH}
            onChange={(e) => {
              setPptName(e.target.value);
              console.info('Setting presentation name');
            }}
            className="p-2 border border-gray-300 w-[400px] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Input type toggle buttons */}
        <div className="mt-4">
          <label className=" font-semibold text-xl text-gray-700 mb-1 block">
          Add  Context <span className="text-red-500">*</span>
          </label>
          <div className="flex gap-4 border-b-2 w-max">
            <button
              onClick={() => {
                handleTextButtonClick();
                console.info('Switching to text input');
              }}
              className={`py-2 px-4 text-center border-b-2 ${
                textView ? "text-blue-500 border-blue-500 font-bold" : "text-black"
              }`}
            >
              From Text
            </button>
            <button
              onClick={() => {
                handleUploadButtonClick();
                console.info('Switching to file upload');
              }}
              className={`py-2 px-4 text-center border-b-2 ${
                !textView ? "text-blue-500 border-blue-500 font-bold" : "text-black"
              }`}
            >
              Upload  File
            </button>
          </div>
        </div>

        {/* Text input area */}
        <div className="  border">
          {textView ? (
            <textarea
              placeholder="Start typing here..."
              value={pdfText}
              onChange={(e) => {
                setPdfText(e.target.value);
                console.info('Updating text content');
              }}
              className="w-full h-[300px] p-2 text-sm  leading-10 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          ) : (
            <div className="flex w-[98vw] justify-center items-center p-1">
              <PdfTextExtractor
                pdfText={pdfText}
                uppyHeight={290}
                setPdfText={setPdfText}
                setTextView={setTextView}
              />
            </div>
          )}
        </div>

        {/* Template selection */}
        <div className="mt-4">
          <h2 className="text-xl font-semibold mb-3">Select Templates<span className="text-red-500">*</span></h2>
          <div className="flex space-x-4 overflow-x-auto">
            {templates.map((template) => (
              <div className="flex flex-col gap-2 justify-center items-center">
                <div
                  key={template.id}
                  onClick={() => {
                    handleSelectTemplate(template);
                    console.info('Selected template:', template.name);
                  }}
                  className={`p-4 w-[245px] relative h-[136px] border flex items-center justify-center shadow-md cursor-pointer transition duration-150
                    ${selectedTemplate.id === template.id ? "text-2xl font-semibold" : "text-gray-700 hover:bg-gray-500"}`}
                  style={{ 
                    backgroundImage: `url(${template.background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                >
                  {selectedTemplate.id === template.id && (
                    <FaCheckCircle className="absolute top-2 h-5 w-5 right-2 text-[#1f36c7] bg-white rounded-full font-bold" />
                  )}
                </div>
                <span>{template.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PPTInputUI